"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNextInstanceOfScheduleDay = exports.showOneTimePaymentPrompt = void 0;
var date_fns_1 = require("date-fns");
var core_1 = require("../../../shared/core");
var showOneTimePaymentPrompt = function (selectedDay, previouslySelectedDay) {
    var retailer = core_1.configService.getConfig().retailer;
    if (retailer.region !== 'AUS' ||
        typeof previouslySelectedDay === 'undefined') {
        return false;
    }
    var todayDay = (0, date_fns_1.startOfToday)().getDate();
    return previouslySelectedDay > todayDay && selectedDay <= todayDay;
};
exports.showOneTimePaymentPrompt = showOneTimePaymentPrompt;
var getNextInstanceOfScheduleDay = function (selectedDay) {
    var todayDay = (0, date_fns_1.startOfToday)().getDate();
    if (todayDay < selectedDay) {
        return (0, date_fns_1.format)((0, date_fns_1.addDays)(new Date(), selectedDay - todayDay), 'yyyy-MM-dd');
    }
    return (0, date_fns_1.format)(new Date(new Date().getFullYear(), new Date().getMonth() + 1, selectedDay), 'yyyy-MM-dd');
};
exports.getNextInstanceOfScheduleDay = getNextInstanceOfScheduleDay;
